<template>
  <div
    class="about"
    style="padding:30px 10px;text-align: left"
  >

    <img
      src="../assets/images/about1.jpg"
      alt=""
      srcset=""
    >
    <img
      src="../assets/images/about2.jpg"
      alt=""
      srcset=""
    >
    <h3 style="margin-bottom: 10px">名称：江苏歪梨信息科技有限公司</h3>
    <h3 style="margin-bottom: 10px">税号：91321002346503166R</h3>
    <h3 style="margin-bottom: 10px">地址：江苏省扬州市邗江区维扬路469号</h3>
    <h3>电话：13738047107</h3>
    <!-- <div style="position: fixed;bottom:60px;left:0;width:100%;text-align:center">
      <div @click="linktobeian">
        naoran.com 苏ICP备17040554号
      </div>
    </div> -->
  </div>
</template>
<script>
import { Toast } from 'vant'
import { useRouter } from 'vue-router'
import { useStore } from 'vuex'
export default {
  name: 'about',
  components: {
  },
  setup () {
    const linktobeian = () => {
      console.log(123)
    }
  }
}
</script>